import ReactDOM from "react-dom/client";
// react mui font imports
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
// slick css imports
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// themes 
import themeIIIFI from "./themes/themeIIIFI";
import { BrowserRouter, Route, Routes } from "react-router";
import Inicio from "./pages/Inicio";
import Investigacion from "./pages/Investigacion";
import Posgrado from "./pages/Posgrado";
import QuienesSomos from "./pages/QuienesSomos";
import Servicios from "./pages/Servicios";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import { ThemeProvider } from "styled-components";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={themeIIIFI}>
    <CssBaseline />
    <Container
      sx={{ marginY: 4, height: "100vh", backgroundColor: "none" }}
      maxWidth={false}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Inicio />} />
          <Route path="/posgrado" element={<Posgrado />} />
          <Route path="/quienes-somos" element={<QuienesSomos />} />
          <Route path="/investigacion" element={<Investigacion />} />
          <Route path="/servicios" element={<Servicios />} />
        </Routes>
      </BrowserRouter>
    </Container>
  </ThemeProvider>
);
